import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import Subtitles from './subtitles-model'
import {
  CreateSubtitlesAsync,
  DeleteSubtitlesAsync,
  LoadSubtitlessAsync,
} from './subtitles-thunk'
const initialState: subtitlesSliceState = {
  subtitles: [],
  selected_subtitles: '',
  is_loading_subtitles: false,
  is_creating_subtitles: false,
  is_deleting_subtitles: false,
}
export interface subtitlesSliceState {
  subtitles: Subtitles[]
  selected_subtitles?: string
  is_loading_subtitles: boolean
  is_creating_subtitles: boolean
  is_deleting_subtitles: boolean
}
export const subtitlesSlice = createSlice({
  name: 'subtitles',
  initialState,
  reducers: {
    setSelectedsubtitles: (state, action) => {
      state.selected_subtitles = action.payload
    },
    clearStatesubtitles: (state) => {
      state.subtitles = []
      state.is_loading_subtitles = false
      state.is_creating_subtitles = false
      state.is_deleting_subtitles = false
    },
    mergesubtitles: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_subtitles = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.subtitles = merge(state.subtitles, payload) as any
        }
      }
    },

    add_subtitles: (state, action) => {
      if (action.payload) {
        state.subtitles = [...state.subtitles, action.payload]
      }
    },
    set_subtitles: (state, action) => {
      let { key, value, id } = action.payload
      state.subtitles = state.subtitles.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadSubtitlessAsync.pending, (state) => {
      state.is_loading_subtitles = true
    })
    builder.addCase(LoadSubtitlessAsync.fulfilled, (state, action) => {
      state.is_loading_subtitles = false
      if (action.payload) {
        state.subtitles = action.payload
      }
    })
    builder.addCase(LoadSubtitlessAsync.rejected, (state) => {
      state.is_loading_subtitles = false
    })
    builder.addCase(CreateSubtitlesAsync.pending, (state) => {
      state.is_creating_subtitles = true
    })
    builder.addCase(CreateSubtitlesAsync.fulfilled, (state) => {
      state.is_creating_subtitles = false
    })
    builder.addCase(CreateSubtitlesAsync.rejected, (state) => {
      state.is_creating_subtitles = false
    })
    builder.addCase(DeleteSubtitlesAsync.pending, (state) => {
      state.is_deleting_subtitles = true
    })
    builder.addCase(DeleteSubtitlesAsync.fulfilled, (state, action) => {
      state.is_deleting_subtitles = false
      if (state.subtitles) {
        state.subtitles = state.subtitles.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteSubtitlesAsync.rejected, (state) => {
      state.is_deleting_subtitles = false
    })

    builder.addCase(autoThunks.fetch_subtitles.pending, (state) => {
      state.is_loading_subtitles = true
    })
    builder.addCase(autoThunks.fetch_subtitles.fulfilled, (state, action) => {
      state.is_loading_subtitles = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.fetch_subtitles.rejected, (state) => {
      state.is_loading_subtitles = false
    })
  },
})

function handleResult(action: any, state: subtitlesSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_subtitles = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.subtitles = merge(state.subtitles, payload) as any
    }
  }
}

export const {
  clearStatesubtitles,
  setSelectedsubtitles,
  set_subtitles,
  mergesubtitles,
  add_subtitles,
} = subtitlesSlice.actions

export const get_subtitles =
  (id?: string) =>
  (state: {
    subtitles: {
      subtitles: Subtitles[]
    }
  }): Subtitles | null => {
    let temp = state?.subtitles?.subtitles?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.subtitles?.subtitles[0] || null
  }
export const get_selected_subtitles = (state: {
  subtitles: subtitlesSliceState
}): Subtitles | null => {
  let id = state?.subtitles?.selected_subtitles
  let temp = state?.subtitles?.subtitles?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_subtitles = (state: {
  subtitles: {
    subtitles: Subtitles[]
  }
}): Subtitles[] => {
  let temp = state?.subtitles?.subtitles
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_subtitles_busy = (state: {
  subtitles: subtitlesSliceState
}) => {
  return (
    state?.subtitles.is_deleting_subtitles ||
    state?.subtitles.is_loading_subtitles ||
    state?.subtitles.is_creating_subtitles
  )
}
export const is_deleting_subtitles_busy = (state: {
  subtitles: subtitlesSliceState
}) => {
  return state?.subtitles.is_deleting_subtitles
}
export const is_loading_subtitles_busy = (state: {
  subtitles: subtitlesSliceState
}) => {
  return state?.subtitles.is_loading_subtitles
}
export const is_creating_subtitles_busy = (state: {
  subtitles: subtitlesSliceState
}) => {
  return state?.subtitles.is_creating_subtitles
}

export default subtitlesSlice.reducer
